// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"8285772e","239":"f7b41e5c","455":"f6706dfc","709":"531b1c03","977":"240c819e"}[chunkId] + ".chunk.js";
};